/**
 * Defines actions related to User Entitled Apps screen.
 */

import * as types from 'constants/ActionTypes';

export const fetchUserEntitledApps = () => ({
  type: types.FETCH_USER_ENTITLED_APPS,
});

export const closeErrorToast = () => ({
  type: types.CLOSE_ERROR_TOAST,
});

export const updateUserOnboardStatus = () => ({
  type: types.UPDATE_USER_ONBOARD_STATUS,
});
